/**
 * Placeholder YouTube URL для `<VideoButton>` на Экране 2.13.2 «Договор».
 * Mirror Block 12 `quoteVideoUrl.ts`. Будет заменён на реальный embed когда
 * продюсер запишет ролик-инструкцию (B-008 / PRD §16.4).
 */
export const CONTRACT_VIDEO_URL = 'https://www.youtube.com/embed/dQw4w9WgXcQ';
